module.exports = __webpack_public_path__ + "static/img/title-2.e3214ba3.svg";